export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent("sellavo:open-cookie-settings"));
}
